import { Modal } from "@components/atoms/Modal";
import Image from "@components/atoms/Image";
import { CarComparisonData } from "@interfaces/CarComparison.types";
import styles from "./CarSelectionModal.module.scss";
import assetLoader, { s3UrlLoader } from "@utils/internalImageLoder";
import { toKebabCase } from "@utils/stringFormatters";
import ImageResponsive from "@components/atoms/ImageResponsive";
import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";

interface CarSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  availableCars: CarComparisonData[];
  onSelectCar: (car: CarComparisonData) => void;
  title?: string;
  currentlySelectedCar?: CarComparisonData | null;
  brandName?: string;
  modelName?: string;
  cityName?: string;
  isLoggedIn?: boolean;
  carAvailability?: string;
  pageType?: string;
}

export default function CarSelectionModal({
  isOpen,
  onClose,
  availableCars,
  onSelectCar,
  title = "Select a car to compare",
  currentlySelectedCar,
  brandName,
  modelName,
  cityName,
  carAvailability,
  pageType,
}: CarSelectionModalProps) {
  const handleCarSelect = async (car: CarComparisonData) => {
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: pageType,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_model",
        section: "Compare",
        car_availability: carAvailability,
        city_name: cityName,
        vehicle_make: brandName,
        vehicle_model: modelName,
      },
    });

    onSelectCar(car);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      overlayClassName={styles.carSelectionModal}
      contentClassName={styles.modalContent}
    >
      <div className={styles.carsList}>
        {availableCars.map((car) => {
          const isCurrentlySelected = currentlySelectedCar?.id === car.id;
          return (
            <div
              key={car.id}
              className={`${styles.carItem} ${
                isCurrentlySelected ? styles.selectedCar : ""
              }`}
              onClick={() => handleCarSelect(car)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleCarSelect(car);
                }
              }}
            >
              <div className={styles.carInnerContainer}>
                <ImageResponsive
                  filePath={`${toKebabCase(car.brand)}/${toKebabCase(
                    car.model
                  )}`}
                  imageTag={`Hero-Transparent`}
                  alt={car?.model}
                  fill
                  className={styles.carImage}
                />
                <span className={styles.carName}>{car.name}</span>
              </div>
              <Image
                src={`${assetLoader()}/icons/Arrow_right_dark.svg`}
                alt="Arrow_right_dark"
                fill
                loading="lazy"
                className={styles.carModalArrow}
              />
            </div>
          );
        })}
      </div>
    </Modal>
  );
}
